import { render, staticRenderFns } from "./BookPreview.vue?vue&type=template&id=29a82c34"
import script from "./BookPreview.vue?vue&type=script&lang=js"
export * from "./BookPreview.vue?vue&type=script&lang=js"
import style0 from "../PresentPublication/PresentPublication.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./BookPreview.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports